import React from 'react';
import Templafy from './Templafy';
import './App.css';

function App() {
  return (
    <div className="App">
      <Templafy />
    </div>
  );
}

export default App;
